import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import MaterialTable from 'material-table';
import tableIcons from 'themes/MaterialTableIcons';
import { Button, Input } from '@mui/material';
import axios from 'axios';
import { Authenticated } from '../../../utils/checkerfunction';
import { useNavigate } from 'react-router-dom';
import { UserData } from 'utils/userData';

const NewAssessment = () => {
    // Authenticated();

    const navigate = useNavigate();

    // setting up columns
    const columns = [
        { title: 'S.No', field: 'id' },
        { title: 'Name', field: 'username' },
        { title: 'Organization', field: 'org_name' },
        { title: 'Day', field: 'day_id' },
        { title: 'ActivityName', field: 'activity_name' },
        { title: 'Level', field: 'levels' },
        { title: 'Category', field: 'category' },
        { title: 'Review', field: 'uploaded_video_url' }
    ];

    const [Data, setData] = React.useState(null);

    const baseURL = `${process.env.REACT_APP_BASEURL}admin/user/getUserVideoList?type=null`;

    axios.defaults.headers.common = {
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };

    const array = [];

    const getData = async () => {
        const response = await axios.get(baseURL);
        response.data.data.forEach((element) => {
            array.push(element);
        });
        setData(array);
    };

    React.useEffect(() => {
        console.log('use Effect Called From new-assessment');
        getData();
        // Authenticated();
    }, []);

    const arr = [];

    // eslint-disable-next-line array-callback-return
    Data?.map((item, i) => {
        if (item.is_approved !== 1 && item.is_approved !== 2) {
            arr.push({
                id: i + 1,
                username: item.username,
                day_id: item.day_id,
                org_name: item.org_name,
                activity_name: item.activity_name,
                levels: item.levels,
                category: item.category,
                uploaded_video_url: item.uploaded_video_url ? (
                    <Button
                        onClick={() =>
                            navigate(
                                `/assessment/view/?name=${item.username}&uservideo=${item.uploaded_video_url}&trainervideo=${item.trainervideo}&activityname=${item.activity_name}&level=${item.levels}&category=${item.category}&day=${item.day_id}&orgname=${item.org_name}&user_video_day_id=${item.user_video_day_id}&enable=true`
                            )
                        }
                    >
                        Review
                    </Button>
                ) : (
                    'No'
                )
            });
        }
    });

    return (
        <MainCard>
            <div>
                <MaterialTable
                    title={null}
                    icons={tableIcons}
                    columns={columns}
                    data={arr}
                    options={{
                        paging: false,
                        maxBodyHeight: '700px',
                        headerStyle: {
                            backgroundColor: '#01579b',
                            color: '#FFF',
                            fontWeight: 100
                        },

                        // eslint-disable-next-line consistent-return
                        rowStyle: (x) => {
                            if (x.tableData.id % 2) {
                                return { backgroundColor: '#eef9ff' };
                            }
                        }
                    }}
                />
            </div>
        </MainCard>
    );
};

export default NewAssessment;
